import React, { useEffect, useState } from 'react'
import { Button, Col, Modal, Row } from 'react-bootstrap'
import { AiFillDelete, AiFillStar, AiOutlineStar } from 'react-icons/ai'
import { BiEdit } from 'react-icons/bi'
import { BsStarHalf } from 'react-icons/bs'
import UseDeleteReview from '../../CustomHooks/Reviews/UseDeleteReview'
import ReactStars from "react-rating-stars-component";
import UseEditReview from '../../CustomHooks/Reviews/UseEditReview'
import DeletePopUp from '../Layout/DeletePopUp'

const RateItem = ({ item, UserLoginId }) => {
    const [reviewUserId, DeleteShow, handleDeleteClose, handleDeleteShow, handleDeleteReview] = UseDeleteReview(item)
    const [rateText, ratevalue, onChangeReviewValue, onChangeRateText, EditShow, handleEditClose, handleEditReview, handleEditShow] = UseEditReview(item)
    let IsUser = false;
    if (reviewUserId == UserLoginId) {
        IsUser = true
    }
    const setting = {
        size: 20,
        count: 5,
        color: "#979797",
        activeColor: "#ffc107",
        value: ratevalue,
        a11y: true,
        isHalf: true,
        edit: false,
        emptyIcon: <AiOutlineStar />,
        halfIcon: <BsStarHalf />,
        filledIcon: <AiFillStar />,
    };
    const setting1 = {
        size: 20,
        count: 5,
        color: "#979797",
        activeColor: "#ffc107",
        value: ratevalue,
        a11y: true,
        isHalf: true,
        emptyIcon: <AiOutlineStar />,
        halfIcon: <BsStarHalf />,
        filledIcon: <AiFillStar />,
    };
    return (
        <>
            <DeletePopUp show={DeleteShow} handleDeleteItem={handleDeleteReview} handleClose={handleDeleteClose} />
            {/* start Edit modal */}
            <Modal show={EditShow} onHide={handleEditClose}>
                <Modal.Header className='orange-bg text-white'>
                    <Modal.Title>Edit Your Review</Modal.Title>
                </Modal.Header>
                <Modal.Body className='py-3 fs-4 fw-bold text-center'>
                    <ReactStars {...setting1} />
                    <input type="text" value={rateText} onChange={onChangeRateText} className='form-control my-3' />
                </Modal.Body>
                <Modal.Footer className='d-flex flex-row justify-content-between align-items-center'>
                    <Button variant="secondary" onClick={handleEditReview} className='orange-bg text-white px-4 py-2'>
                        Yes
                    </Button>
                    <Button variant="primary" onClick={handleEditClose} className='px-4 py-2'>
                        No
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* end Edit modal */}
            <Row className="mt-3">
                <Col>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="fs-20 d-inline-block">{item.user.name} </div>
                        {IsUser === true ? (<div>
                            <AiFillDelete className='mx-3 fs-5 orange-color pointer-cursor' onClick={handleDeleteShow} />
                            <BiEdit className='mx-3 fs-5 dark-color pointer-cursor' onClick={handleEditShow} />
                        </div>) : null}
                    </div>
                    <ReactStars {...setting} />
                    <p className="fs-20">
                        {item.review}
                    </p>
                </Col>
            </Row>
        </>
    )
}

export default RateItem
